import {makeObservable} from 'mobx';

import type {DateTimeModel} from '../Date/DateTime.model';

import {BaseModel} from '../../../core/domain/Base/Base.model';

const ModelName = 'CardModel';

export class CardModel extends BaseModel {
  brand: CardModel.Brand;
  created: DateTimeModel;
  expMonth: number;
  expYear: number;
  last4: string;
  type: CardModel.Type;
  updated: DateTimeModel;

  constructor(props: CardModel.Props) {
    super(props);

    Object.assign(this, props);

    makeObservable(this, BaseModel.mobxAnnotationFactory(props));
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }

  override toString() {
    return `···· ${this.last4}`;
  }
}

export namespace CardModel {
  /**
   * @see https://docs.stripe.com/api/cards/object
   */
  export enum Brand {
    AMERICAN_EXPRESS = 'american express',
    DINERS_CLUB = 'diners club',
    DISCOVER = 'discover',
    EFTPOS_AUSTRALIA = 'eftpos australia',
    JCB = 'jcb',
    MASTERCARD = 'mastercard',
    UNIONPAY = 'unionpay',
    UNKNOWN = 'unknown',
    VISA = 'visa',
  }

  export enum Type {
    CARD = 'card',
    INTENT = 'setup_intent',
  }

  export type Props = BaseModel.ModelToProps<CardModel>;
}
